import "./pt-electric-switch.css"
import  OPEN_CLOSED from "../../mixins/OPEN_CLOSED"

export default {
    mixins: [OPEN_CLOSED]
}
